/**
 * Miscellaneous semantic tokens for PrimeNG preset
 * Includes global settings and utility tokens
 */

import * as p from '../tokens/primitives.js';
import { border, type SemanticTokens } from '../tokens/semantic.js';

export const misc = {
  // Global settings
  disabledOpacity: '0.6',
  anchorGutter: '2px',

  // Content
  content: {
    border: {
      radius: p.borderRadius[8],   // 8px (standard content radius)
      color: border.default,
      width: '1px',
    },
  },
};

export function createMisc(s: SemanticTokens) {
  return {
    disabledOpacity: '0.6',
    anchorGutter: '2px',
    content: {
      border: {
        radius: p.borderRadius[8],
        color: s.border.default,
        width: '1px',
      },
    },
  };
}
